import React, { useState } from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { NotificationManager } from "react-notifications";
import { required, isDec3 } from "../../../../constants/formValidators";
import { FormField } from "../../../../sharedComponents/formField";
import { saveFoodItem, saveMyFoodItem, addFoodItem, addMyFoodItem } from "../../../../store/actions";

const ServingsType = ({
	setActiveTab,
	initialValues,
	saveFoodItem,
	saveMyFoodItem,
	addFoodItem,
	addMyFoodItem,
	handleSubmit,
	isAdmin,
	history,
}) => {
	const [submitting, setSubmitting] = useState();

	const match = window.location.href;
	const isApproval = match.indexOf("/approval") > -1 ? true : false;


	const validateForm = (values) => {

	     setSubmitting(true)

		 if(Number(values.servings_fat) === 0 &&
		 Number(values.servings_vegetable) === 0 &&
		 Number(values.servings_fruit) === 0 &&
		 Number(values.servings_dairy) === 0 &&
		 Number(values.servings_starch) === 0 &&
		 Number(values.servings_misc) === 0 ){
			return NotificationManager.warning("Atleast one servings type is required!", "", 5000);
		 }

		const successHandler = (res) => {
			res.json().then((data) => {
				isApproval
					? history.push(`/nutrition/food-database/approval/${data.id}/add`)
					: history.push(`/nutrition/food-database/${data.id}/add`);
				setSubmitting(false);
				setActiveTab(2);
			});
		};

		if (initialValues && initialValues.id) {
			if (initialValues === values) {
				setSubmitting(false);
				setActiveTab(2);
			} else {
				if (isAdmin) {
					saveFoodItem(values, successHandler);
				} else {
					saveMyFoodItem(values, successHandler);
				}
			}
		} else {
			if (isAdmin) {
				addFoodItem(values, successHandler);
			} else {
				addMyFoodItem(values, successHandler);
			}
		}
	};

	return (
		<form className="p-4" onSubmit={handleSubmit(validateForm)}>
			<div className="row">
				<Field
					label="Servings Fat"
					name="servings_fat"
					type="number"
					formGroupClass="col-3"
					component={FormField}
					validate={[required, isDec3]}
					min="0"
					max="9999"
					step="0.001"
					onChange={() => setSubmitting(false)}
				/>
				<Field
					label="Servings Vegetables"
					name="servings_vegetable"
					type="number"
					formGroupClass="col-3"
					component={FormField}
					validate={[required, isDec3]}
					min="0"
					max="9999"
					step="0.001"
					onChange={() => setSubmitting(false)}
				/>

				<Field
					label="Servings Fruits"
					name="servings_fruit"
					type="number"
					formGroupClass="col-3"
					component={FormField}
					validate={[required, isDec3]}
					min="0"
					max="9999"
					step="0.001"
					onChange={() => setSubmitting(false)}
				/>
				<Field
					label="Servings Diary"
					name="servings_dairy"
					type="number"
					formGroupClass="col-3"
					component={FormField}
					validate={[required, isDec3]}
					min="0"
					max="9999"
					step="0.001"
					onChange={() => setSubmitting(false)}
				/>

				<Field
					label="Servings Starch"
					name="servings_starch"
					type="number"
					formGroupClass="col-3"
					component={FormField}
					validate={[required, isDec3]}
					min="0"
					max="9999"
					step="0.001"
					onChange={() => setSubmitting(false)}
				/>

				<Field
					label="Servings Misc"
					name="servings_misc"
					type="number"
					formGroupClass="col-3"
					component={FormField}
					validate={[required, isDec3]}
					min="0"
					max="9999"
					step="0.001"
					onChange={() => setSubmitting(false)}
				/>
			</div>

			<div className="text-right mt-4">
				<button className="btn btn-primary-dark" type="submit" disabled={submitting}>
					Save &amp; Next
				</button>
			</div>
		</form>
	);
};

const mapDispatchToProps = { saveFoodItem, saveMyFoodItem, addFoodItem, addMyFoodItem };

export default connect(
	null,
	mapDispatchToProps
)(
	reduxForm({
		form: "ServingsType",
		enableReinitialize: true,
	})(ServingsType)
);
